"use client";

import { useState } from "react";
import { Icon } from "@/components/ui/icon";
import { usePaymentMethod } from "../hooks/use-subscription";
import { UpdatePaymentModal } from "./update-payment-modal";

const BRAND_DISPLAY: Record<string, string> = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "Amex",
  discover: "Discover",
  diners: "Diners Club",
  jcb: "JCB",
  unionpay: "UnionPay",
};

export function PaymentMethodCard() {
  const { data: paymentMethod, isLoading } = usePaymentMethod();
  const [showModal, setShowModal] = useState(false);

  if (isLoading) return <PaymentMethodSkeleton />;

  return (
    <>
      <div className="rounded-lg border border-white/10 bg-white/2">
        <div className="flex items-center justify-between px-5 py-4">
          <h3 className="text-sm font-semibold text-heading">Payment Method</h3>
          <button
            type="button"
            onClick={() => setShowModal(true)}
            className="h-8 px-3 rounded-md text-sm font-medium bg-white/4 border border-white/15 text-white/70 hover:text-white hover:bg-white/8 transition-colors cursor-pointer shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05),inset_0px_-1px_0px_0px_rgba(0,0,0,0.08)]"
          >
            {paymentMethod ? "Update" : "Add"}
          </button>
        </div>

        <div className="border-t border-white/10 px-5 py-4">
          {paymentMethod ? (
            <div className="flex items-center gap-3">
              <div className="size-10 rounded-lg bg-white/4 border border-white/10 flex items-center justify-center shrink-0">
                <Icon
                  name="IconCreditCard1"
                  size={18}
                  className="text-muted-foreground"
                />
              </div>
              <div className="flex flex-col gap-0.5">
                <span className="text-sm font-medium text-heading">
                  {BRAND_DISPLAY[paymentMethod.brand] ?? paymentMethod.brand}{" "}
                  ending in {paymentMethod.last4}
                </span>
                <span className="text-xs text-muted-foreground">
                  Expires {String(paymentMethod.exp_month).padStart(2, "0")}/
                  {paymentMethod.exp_year}
                </span>
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <div className="size-10 rounded-lg bg-white/4 border border-white/10 flex items-center justify-center shrink-0">
                <Icon
                  name="IconCreditCard1"
                  size={18}
                  className="text-muted-foreground"
                />
              </div>
              <span className="text-sm text-muted-foreground">
                No payment method on file
              </span>
            </div>
          )}
        </div>
      </div>

      <UpdatePaymentModal open={showModal} onOpenChange={setShowModal} />
    </>
  );
}

function PaymentMethodSkeleton() {
  return (
    <div className="rounded-lg border border-white/10 bg-white/2">
      <div className="flex items-center justify-between px-5 py-4">
        <div className="h-4 w-28 rounded bg-white/6 animate-pulse" />
        <div className="h-8 w-16 rounded-md bg-white/4 animate-pulse" />
      </div>
      <div className="border-t border-white/10 px-5 py-4">
        <div className="flex items-center gap-3">
          <div className="size-10 rounded-lg bg-white/4 animate-pulse" />
          <div className="flex flex-col gap-1">
            <div className="h-3.5 w-36 rounded bg-white/6 animate-pulse" />
            <div className="h-3 w-20 rounded bg-white/4 animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
}
